/// <reference path="../invoices/InvoiceListViewController.ts" />
/// <reference path="../AppHelper.ts" />

class QuotationListViewController extends DocumentListViewController
{
    static newInstance():QuotationListViewController {
        let vc = new QuotationListViewController("quotation-list-view");        
        vc.initWithResource("layout/quotation_documents/QuotationListView.html");        
        return vc;
    }
    
    get entityName():string { return "QuotationDocument"; }

    viewDidLoad() {
        super.viewDidLoad();
        
        // this.titleLabel.text = MIOLocalizeString("QUOTATIONS", "QUOTATIONS");
        this.addButton.setAction(this, this.addQuotationAlert);
    }

    // titleForHeaderInSection(tableView:UITableView, section:number){
    //     if (this.fetchedResultsController.sections.length < 2) return null;
        
    //     let ip = MIOIndexPath.indexForRowInSection(0, section);
    //     let item = this.fetchedResultsController.objectAtIndexPath(ip) as QuotationDocument;
                
    //     return item.monthString;
    // }

    cellAtIndexPath(tableview:UITableView, indexPath:MIOIndexPath){
        let cell = tableview.dequeueReusableCellWithIdentifier("QuotationCell") as QuotationListCell;

        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as QuotationDocument;
        cell.item = item;
        cell.selected = (this.selectedItem?.identifier == item.identifier);

        return cell;
    }

    protected showSelectedItem() {
        let vc = QuotationDetailViewController.newInstance();
        vc.item = this.selectedItem;
        this.splitViewController.showDetailViewController(vc);
    }

    get fetchedResultsController(){
        if (this._fetchedResultsController != null)
            return this._fetchedResultsController;
    
        let ad:AppDelegate = MUIWebApplication.sharedInstance().delegate;
            
        let sds = [ 
            MIOSortDescriptor.sortDescriptorWithKey("date", false), 
            MIOSortDescriptor.sortDescriptorWithKey("documentNumber", false)
        ];

        let predicates = ["deletedAt == null"]
        if (this.searchString != null) {
            predicates.addObject ("(documentNumber CONTAINS '" + this.searchString + "'" + " OR legalEntity.name CONTAINS '" + this.searchString + "'" + ")");
        }
		                
        let predicateFormat = predicates.join(" AND ");
    
        let fetchRequest = DBHelper.listFetchRequestWithEntityName(this.entityName, sds, predicateFormat);
        fetchRequest.fetchLimit = 500;
        // fetchRequest.relationshipKeyPathsForPrefetching = ["legalEntity", "nextDocument"];

        let fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, "sectionDateString");
        fetchedResultsController.delegate = this;
    
        fetchedResultsController.performFetch();
    
        this._fetchedResultsController = fetchedResultsController;    
        return this._fetchedResultsController;
    }

    protected addQuotationAlert(){
        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("OPTIONS", "OPTIONS"), MIOLocalizeString("SELECT_AN_OPTION", "SELECT AN OPTION"), MUIAlertViewStyle.Default);

        avc.addTextFieldWithConfigurationHandler(this, function(textField:MUITextField){
            textField.setPlaceholderText(MIOLocalizeString("REFERENCE","REFERENCE"));
        });
        
        avc.addAction( MUIAlertAction.alertActionWithTitle( MIOLocalizeString("OK", "OK"), MUIAlertActionStyle.Default, this, function(this:QuotationListViewController){            
            this.createNewQuotation(avc.textFields[0].text);
        }));

        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null) );

        avc.addCompletionHandler(this, function () {
            // Release the observers                        
        });

        this.presentViewController(avc, true);
    }

    protected createNewQuotation(reference:string){
        DBHelper.nextDocumentNumber("QuotationDocument", 0, (documentID:string, documentPrefix:string, documentNumber:number, error:string) => {
            if (error != null) {
                AppHelper.showErrorMessage(this, MIOLocalizeString("ERROR", "ERROR"), error);
                return;
            }

            this._createNewQuotation(reference, documentID);
        });
    }

    protected _createNewQuotation(reference:string, documentNumber:string){
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        let doc = MIOEntityDescription.insertNewObjectForEntityForName( this.entityName, ad.managedObjectContext ) as QuotationDocument;

        doc.identifier = MIOUUID.UUID().UUIDString;
        doc.documentNumber = documentNumber;
        doc.date = new Date();
        
        this.selectedItem = doc;
        
        DBHelper.saveMainContext();
        this.showSelectedItem();
    }
}
